module.exports = __webpack_public_path__ + "img/iconLogo.c53d3557.png";